<template>
  <el-dialog
    title="标签管理"
    :visible.sync="dialogVisible"
    append-to-body
    width="400px"
    class="createTag"
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText" class="tag-input">
      <span slot="suffix" @click="addTag" style="cursor:pointer;color:#409EFF;font-size: 22px;">
        <el-tooltip content="添加标签">
          <i class="el-input__icon el-icon-circle-plus"></i>
        </el-tooltip>
      </span>
    </el-input>
    <span class="title">所有标签</span>
    <el-scrollbar style="height:250px">
      <el-tree
        :data="source"
        node-key="ID"
        :filter-node-method="filterNode"
        ref="tagTree"
        default-expand-all
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <div class="row">
            <span class="icon-span" :style="getColor(data.COLOR)">
              <i class="el-icon-price-tag"></i>
            </span>
            <span style="margin-left: 10px;font-size: 14px;">{{data.TAGNAME}}</span>
            <div style="margin-left: auto; display:flex;align-item:center">
              <el-tooltip :content="data.MyDefault?'点击取消关注':'点击关注'">
                <span @click="changeCommonTag(data)" style="color:#ffc442;cursor:pointer">
                  <i v-if="data.MyDefault" class="el-icon-star-on"></i>
                  <i v-else class="el-icon-star-off"></i>
                </span>
              </el-tooltip>
              <el-tooltip content="编辑">
                <el-link
                  style="margin:0 10px"
                  :disabled="data.CREATEUSERID!=curUserId"
                  @click="editTag(data)"
                  :underline="false"
                >
                  <i class="el-icon-edit"></i>
                </el-link>
              </el-tooltip>
              <el-tooltip content="删除">
                <el-link
                  @click="deleteTag(data)"
                  :disabled="data.CREATEUSERID!=curUserId"
                  :underline="false"
                >
                  <i class="el-icon-delete"></i>
                </el-link>
              </el-tooltip>
            </div>
          </div>
        </span>
      </el-tree>
    </el-scrollbar>
    <CreateTag ref="createTag" :editTag="editorTag" @success="success"></CreateTag>
  </el-dialog>
</template>
//标签管理
<script>
import {
  AddCommonTag,
  DelCommonTag,
  DelTag
} from "@/api/modules/basicData/task";
import CreateTag from "./CreateTag.vue";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
const person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.companyId,
  COMPANYNAME: cookieUser.companyName
};
export default {
  components: {
    CreateTag
  },
  props: {
    tagsource: {
      //[commontags,alltags]
      type: Array,
      default: () => []
    }
  },
  watch: {
    tagsource(newValue) {
      if (newValue && newValue.length > 0) {
        var commonTags = newValue[0];
        var allTags = Object.assign([], newValue[1]);
        allTags.forEach(
          o => (o.MyDefault = commonTags.some(tag => tag.TAGID == o.ID))
        );
        this.source = allTags;
      }
    },
    filterText(val) {
      this.$refs.tagTree.filter(val);
    }
  },
  data() {
    return {
      dialogVisible: false,
      editorTag: null,
      filterText: "",
      curUserId: cookieUser.userId,
      source: []
    };
  },
  methods: {
    open(newValue) {
      if (newValue && newValue.length > 0) {
        var commonTags = newValue[0];
        var allTags = Object.assign([], newValue[1]);
        allTags.forEach(
          o => (o.MyDefault = commonTags.some(tag => tag.TAGID == o.ID))
        );
        this.source = allTags;
      }
      this.dialogVisible = true;
    },
    success() {
      this.$emit("success");
    },
    getColor(color) {
      return `color:${color}`;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.TAGNAME.indexOf(value) !== -1;
    },
    addTag() {
      this.editorTag = null;
      this.$refs.createTag.dialogVisible = true;
    },
    editTag(data) {
      this.editorTag = data;
      this.$refs.createTag.dialogVisible = true;
    },
    deleteTag(data) {
      DelTag(data.ID, person).then(result => {
        if (result.ResultCode > 0) {
          this.$message.info("删除成功");
          this.$emit("success");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    changeCommonTag(data) {
      if (!data.MyDefault) {
        AddCommonTag({
          TAGID: data.ID,
          CREATEUSERID: cookieUser.userId,
          CREATEUSERNAME: cookieUser.realName,
          CREATEDEPTID: cookieUser.departmentId,
          CREATEDEPTNAME: cookieUser.departmentName,
          CREATECOMPANYID: cookieUser.companyId,
          CREATECOMPANYNAME: cookieUser.companyName
        }).then(result => {
          if (result.ResultCode > 0) {
            data.MyDefault = !data.MyDefault;
            this.$emit("success");
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      } else {
        DelCommonTag(data.ID, person).then(result => {
          if (result.ResultCode > 0) {
            data.MyDefault = !data.MyDefault;
            this.$emit("success");
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  line-height: 30px;
  padding: 5px;
  font-size: 13px;
  color: #c1c1c1;
}
.custom-tree-node {
  width: 90%;
}
.row {
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 5px;
  width: 100%;
}

.icon-span {
  color: #22d7bb;
  font-size: 18px;
}
</style>